import React, { useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import {
  EmailNote,
  VendorDetailState,
} from "../../../reducers/vendor/VendorDetailReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AllActions from "../../../actions";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import {
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  TextField,
  ListItemSecondaryAction,
  IconButton,
  Grid,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";
import { FormUtil } from "../../../utils/FormUtil";
import {
  FieldsLengthConstants,
  InforDisplyaDuration,
} from "../../../constants/AppConstants";

export interface ContactDetailEmailDialogProps {
  open: boolean;
  setOpen: any;
  isEditmode: boolean;
}

export default function ContactDetailEmailDialog(
  props: ContactDetailEmailDialogProps
) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, setOpen, isEditmode } = props;
  const [emailTextval, setEmailTextval] = useState("");
  const [noteTextval, setNoteTextval] = useState("");
  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  const handleEmailChange = (e: any) => {
    //auto fill note with email
    setNoteTextval(e.target.value);
  };

  const handleAddPress = (e: any) => {
    if (emailTextval) {
      let index = vendorDetail.EmailNoteList.findIndex(function (
        emailnote: EmailNote
      ) {
        return emailnote.emailAddress === emailTextval;
      });
      if (index === -1) {
        //validate email
        if (FormUtil.isValidEmail(emailTextval)) {
          setEmailTextval("");
          setNoteTextval("");
          dispatch(
            AllActions.vendorDetailActions.addEmailNote(
              emailTextval,
              noteTextval
            )
          );
        } else {
          dispatch(
            AllActions.infoActions.openInforWarn(
              translation.vendor_detail_contactdetails_popup_email_validateerror,
              InforDisplyaDuration.common
            )
          );
        }
      } else {
        dispatch(
          AllActions.infoActions.openInforWarn(
            translation.vendor_detail_contactdetails_popup_email_alredy,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const handleRemove = (emailenote: EmailNote) => {
    dispatch(
      AllActions.vendorDetailActions.removeEmailNote(emailenote.emailAddress)
    );
  };

  const onCloseBtnClick = () => {
    handleClose();
  };

  const handleClose = () => {
    setEmailTextval("");
    setNoteTextval("");
    setOpen(false);
  };

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitle className={classes.popUpHeader}>
          {translation.vendor_detail_contactdetails_popup_email_titile}
        </DialogTitle>

        <DialogContent>
          <Grid
            className={classes.NoPopWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            {isEditmode && (
              <div>
                <div>
                  <span className={classes.popUpLBL}>Email </span>
                  <div>
                    <TextField
                      variant="outlined"
                      value={emailTextval}
                      onChange={(e) => setEmailTextval(e.target.value)}
                      inputProps={{
                        maxLength: FieldsLengthConstants.VendorEmail,
                      }}
                    />
                    <IconButton
                      onClick={handleAddPress}
                      disabled={!emailTextval}
                    >
                      <div className={classes.popUpAddBtn}>
                        <AddCircleIcon>
                          {" "}
                          {
                            translation.vendor_detail_contactdetails_popup_email_add
                          }
                        </AddCircleIcon>
                      </div>
                    </IconButton>
                  </div>
                </div>
              </div>
            )}

            <List className={classes.listWrapper}>
              {vendorDetail.EmailNoteList.map((emailenote, index) => (
                <ListItem alignItems="flex-start" key={emailenote.emailAddress}>
                  <ListItemText
                    primary={emailenote.emailAddress}
                    // secondary={
                    //   <React.Fragment>
                    //     <Typography
                    //       component="span"
                    //       variant="body2"
                    //       color="textPrimary"
                    //     >
                    //        {emailenote.note}
                    //     </Typography>

                    //   </React.Fragment>
                    // }
                    onChange={handleEmailChange}
                  />
                  {/* <ListItemText primary={emailenote.note} /> */}
                  {isEditmode && (
                    <ListItemSecondaryAction>
                      <IconButton
                        onClick={() => handleRemove(emailenote)}
                        className={classes.popUpDeleteBtn}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              ))}
            </List>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div style={{ float: "left", margin: "20px 10px 0px 0" }}>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={onCloseBtnClick} color="primary" autoFocus>
                {translation.file_download_close_btn_lbl}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
